module.exports = __webpack_public_path__ + "static/media/logo_black.1e8e10d8.png";